import { Link } from 'react-router-dom';
import type { BoardConfig, Post } from '../types/board.type.ts';

interface DetailNavProps {
  config: BoardConfig<Post>;
  prev: Post | null;
  next: Post | null;
}

/**
 * 상세 페이지 하단 이전/다음 글 이동.
 * 목록 정렬 기준(고정글 우선 → 최신순)과 동일한 순서로 BE 가 내려준
 * prev/next 를 받아 표시한다. 없으면 비활성.
 */
export function DetailNav({ config, prev, next }: DetailNavProps) {
  return <nav className="mt-12 divide-y divide-black/[0.06] dark:divide-white/10 border-y border-black/10 dark:border-white/10">
    <NavRow config={config} dir="prev" post={prev} />
    <NavRow config={config} dir="next" post={next} />
  </nav>
}

function NavRow({
  config,
  dir,
  post,
}: {
  config: BoardConfig<Post>;
  dir: 'prev' | 'next';
  post: Post | null;
}) {
  const label = dir === 'prev' ? '이전 글' : '다음 글';
  const arrow = dir === 'prev' ? '↑' : '↓';

  if (!post) {
    return (
      <div className="flex items-center gap-4 px-1 py-4 text-neutral-400 dark:text-neutral-500">
        <span className="w-16 shrink-0 text-[13px] font-semibold">{label}</span>
        <span className="text-[14px]">{arrow} 없음</span>
      </div>
    );
  }

  return (
    <Link
      to={config.detailPath(post.id)}
      className="group flex items-center gap-4 px-1 py-4 transition-colors hover:bg-black/[0.02] dark:hover:bg-white/10"
    >
      <span className="w-16 shrink-0 text-[13px] font-semibold text-neutral-950/60 dark:text-white/60">
        {label}
      </span>
      <span className="min-w-0 flex-1 truncate text-[14px] text-neutral-800 dark:text-neutral-200 group-hover:text-primary">
        {arrow} {post.title}
      </span>
    </Link>
  );
}
